
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AddressFieldsProps {
  address: string;
  city: string;
  state: string;
  postalCode: string;
  onAddressChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCityChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPostalCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  labelClassName?: string;
}

export const AddressFields = ({
  address,
  city,
  state,
  postalCode,
  onAddressChange,
  onCityChange,
  onStateChange,
  onPostalCodeChange,
  labelClassName
}: AddressFieldsProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="address" className={labelClassName}>Street Address</Label>
        <Input
          id="address"
          value={address || ''}
          onChange={onAddressChange}
          placeholder="Enter your street address"
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>

      <div>
        <Label htmlFor="city" className={labelClassName}>City</Label>
        <Input
          id="city"
          value={city || ''}
          onChange={onCityChange}
          placeholder="Enter your city"
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>

      <div>
        <Label htmlFor="state" className={labelClassName}>State</Label>
        <Input
          id="state"
          value={state || ''}
          onChange={onStateChange}
          placeholder="Enter your state"
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>

      <div>
        <Label htmlFor="postalCode" className={labelClassName}>Postal Code</Label>
        <Input
          id="postalCode"
          value={postalCode || ''}
          onChange={onPostalCodeChange}
          placeholder="Enter your postal code"
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>
    </div>
  );
};
